// extracted by mini-css-extract-plugin
export default {"overlay":"dialog_overlay__mXowX","content":"dialog_content__XktpV","text":"dialog_text__54u8E","actions":"dialog_actions__rm2aC"};